module.exports = __webpack_public_path__ + "static/img/20.182f0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/20.png
// module id = QeE0
// module chunks = 1